import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Button } from '@metarouter-private/mr-mui';

export default function FileUploadInput({ fileInputKey, selectedFile, onChange }) {
  return (
    <Stack spacing={1}>
      <Button variant="outlined" component="label">
        Choose File
        <input
          key={fileInputKey}
          type="file"
          accept=".yaml,.yml"
          onChange={onChange}
          hidden
          data-test-id="upload-file-input"
        />
      </Button>
      {selectedFile && (
        <Typography variant="body2" color="text.secondary">
          Selected: {selectedFile.name}
        </Typography>
      )}
    </Stack>
  );
}

FileUploadInput.propTypes = {
  fileInputKey: PropTypes.number.isRequired,
  selectedFile: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
